import { RequestResponse } from "@api";
import { RowWrapper } from "../../types";
import { BaseFiltersDropdown, EFFECTIVE_DATE, Filters } from "./types";

const isBefore = (date: Date | null, date2: Date | null): boolean => {
  if (!!date && !!date2) {
    date.setHours(0, 0, 0);
    date2.setHours(0, 0, 0);
    return date.getTime() <= date2.getTime();
  }
  return false;
};

export const filterTable = (data: RequestResponse, filters: Filters) => {
  let passed = true;
  if (!!filters.status) {
    passed = data.status.toLowerCase() === filters.status.toLowerCase();
  }

  if (!!filters.environment) {
    passed =
      passed &&
      data.environment?.toLowerCase() === filters.environment.toLowerCase();
  }

  if (!!filters.systemName) {
    passed =
      passed &&
      data.subCategory?.toLowerCase() === filters.systemName.toLowerCase();
  }

  if (!!filters.typeOfAction) {
    passed =
      passed &&
      data.requestType?.toLowerCase() === filters.typeOfAction.toLowerCase();
  }

  if (!!filters.dateType) {
    if (filters.dateType === EFFECTIVE_DATE) {
      passed =
        passed && isBefore(filters.dateFrom, new Date(data.effectiveDate));
      passed = passed && isBefore(new Date(data.effectiveDate), filters.dateTo);
    } else {
      passed = passed && isBefore(filters.dateFrom, new Date(data.dateAdded));
      passed = passed && isBefore(new Date(data.dateAdded), filters.dateTo);
    }
  }

  if (!!filters.systemCategory) {
    passed =
      passed &&
      data.category?.toLowerCase() === filters.systemCategory.toLowerCase();
  }

  if (!!filters.systemType && data.systemType !== undefined) {
    passed =
      passed &&
      data.systemType?.toLowerCase() === filters.systemType.toLowerCase();
  }

  if (!!filters.withRF && filters.withRF == "With RFNo.") {
    passed =
      passed &&
      data.serviceTicketNumber?.toLowerCase() !== undefined;
  }

  if (!!filters.withRF && filters.withRF == "Without RFNo.") {
    passed =
      passed &&
      (data.serviceTicketNumber?.toLowerCase() == undefined || data.serviceTicketNumber?.trim().toLowerCase() == "");
  }
  
  if (!!filters.deviceType) {
    passed = (data.deviceType?.toLowerCase() === filters.deviceType.toLowerCase()) ? true : false;
  }

  if (!!filters.isSendBack) {
    passed = passed && data?.isSendBack === filters.isSendBack;
  } else {
    return passed; //if we set isSendBack true at least once it will stay true for ever.... did not find a better way to do it
  }

  return passed;
};

export const filloutDropdowns = (
  requests: RowWrapper<RequestResponse>[],
  excludeDraftsFromStatuses?: boolean
): BaseFiltersDropdown => {
  let environments: string[] = [];
  let systemNames: string[] = [];
  let statuses: string[] = [];
  let systemCategories: string[] = [];
  let systemTypes: string[] = [];
  let deviceTypes: string[] = [];
  let withRFs: string[] = [];

  requests.forEach((request) => {
    const {
      environment,
      subCategory,
      status,
      category,
      systemType,
      deviceType,
    } = request.row.data;
    if (!!environment && !environments.some((value) => value === environment)) {
      environments.push(environment);
    }
    //TODO: check if the subcategory is the system names
    if (!!subCategory && !systemNames.some((value) => value === subCategory)) {
      systemNames.push(subCategory);
    }

    if (!!status && !statuses.some((value) => value === status)) {
      // [TODO] Check if this is working. REF: DEF180
      // https://docs.google.com/spreadsheets/d/1IWYLfnoxQfubBqWDx4lxLx0gK4E4TKqzMIO7iuyivH0/edit?ts=5f06e88f#gid=467763240
      if (status.toUpperCase() !== "DRAFT" || !excludeDraftsFromStatuses) {
        statuses.push(status);
      }
    }

    if (!!category && !systemCategories.some((value) => value === category)) {
      systemCategories.push(category);
    }

    if (!!deviceType && !deviceTypes.some((value) => value === deviceType)) {
      deviceTypes.push(deviceType);
    }

    if (!!systemType && !systemTypes.some((value) => value === systemType)) {
      systemTypes.push(systemType);
    }
  });

  return {
    environments,
    systemNames,
    statuses,
    systemCategories,
    systemTypes,
    deviceTypes,
    withRFs
  };
};
